import { createSelector } from 'reselect';

import { GuestData } from 'state/calendarCrm';
import { StoreType } from '@tock/shared/utils/connect';

export const calendarCrmGuestDataSelector = createSelector(
  (state: StoreType) => state.calendarCrm.guestData,
  (guestData: NumericDictionary<GuestData>): NumericDictionary<GuestData> => guestData
);
